// 登陆，退出登陆接口
import request from "./http";
let usResponseData = {
    code: '200',
    data: null,
}
let isUsProd = process.env.VUE_APP_ENV == 'usprod'? true: false


// 登陆
export const login = data => {
    if (isUsProd) {
        return usResponseData
    } else {
        return request({
            method: 'post',
            url: '/auth/sys/login',
            data
        })
    }
}


// 发送验证码
export const sendValidCode = data => {
    if (isUsProd) {
        return usResponseData
    } else {
        return request({
            method: 'get',
            url: '/auth/user/getPhoneCode?phone=' + data,
        })
    }
}


// 忘记密码
export const forgetPassword = data => {
    if (isUsProd) {
        return usResponseData
    } else {
        return request({
            method: 'post',
            url: '/auth/access/modifyPassWord',
            data
        })
    }
}

// 修改密码
export const changePassword = data => {
    if (isUsProd) {
        return usResponseData
    } else {
        return request({
            method: 'post',
            url: '/auth/user/modifyPassWord',
            data
        })
    }

}

// 根据用户名查询系统信息
export const searchSystemInfo = data => {
    if (isUsProd) {
        return usResponseData
    } else {
        return request({
            method: 'get',
            url: '/auth/system/finBySystemInfo?userName='+data,
        })
    }

}

// 根据系统id查询系统信息
export const findBySystemInfo = data => {
    if (isUsProd) {
        return usResponseData
    } else {
        return request({
            method: 'get',
            url: '/auth/system/finBySystemInfo?userCode='+data
        })
    }

}

// 选择登陆的系统
export const changeCompany = data => {
    if (isUsProd) {
        return usResponseData
    } else {
        return request({
            method: 'get',
            url: '/auth/sys/changeCompanyId?companyId='+data
        })
    }

}

// 退出登陆
// export const layout = data => {
//     return request({
//         method: 'post',
//         url: '/logout/submit'
//     })
// }
